// app/javascript/jquery-global.js
// Sets window.jQuery and window.$ so that UMD/legacy jQuery plugins
// (cocoon, select2, daterangepicker, typeahead, tagsinput) can find the
// global when their modules evaluate.
//
// WHY a separate module:
//   In ESM (and esbuild bundles), all `import` declarations in a file are
//   evaluated BEFORE the importing file's own body executes.  That means:
//
//     import $ from "jquery"          ← evaluated 1st
//     window.jQuery = window.$ = $    ← runs in body (step 3, too late!)
//     import "@nathanvda/cocoon"      ← evaluated 2nd, before step 3
//
//   By moving the assignment into its own module and importing that module
//   BEFORE any jQuery plugins, the assignment runs during THIS module's
//   evaluation — which happens before the plugins' modules evaluate.

import $ from "jquery"
window.jQuery = window.$ = $

// jQuery 4 removed several utility functions that legacy plugins still use.
// Polyfill them here so corejs-typeahead/Bloodhound, FullCalendar v3, and
// any other jQuery ≤ 3.x-era plugin continues to work.
// These are trivially equivalent to the native functions — no behaviour change.
if (!$.isArray)    { $.isArray    = Array.isArray }
if (!$.isFunction) { $.isFunction = (f) => typeof f === "function" }
if (!$.trim)       { $.trim       = (s) => (s == null ? "" : String(s).trim()) }
if (!$.type)       { $.type       = (obj) => obj == null ? String(obj) : typeof obj }
// Select2 4.x uses $.camelCase internally (removed in jQuery 4).
if (!$.camelCase)  { $.camelCase  = (s) => s.replace(/-([a-z])/g, (_, c) => c.toUpperCase()) }

export { $ as default, $ }

